/*
商談予約ページのモーダル表示
*/
import axios from "axios";
import { showLoading } from "./../../module/loading";
import { hideLoading } from "./../../module/loading";
export function reservationCalendarModal() {
    reservationBtn();
}
let eventId = "";
function reservationBtn() {
    // 各モーダルを定義
    const modalReserve = document.getElementById("reserve-modal");
    const modalConfirm = document.getElementById("confirm-modal");
    const modalComplete = document.getElementById("complete-modal");
    // 各モーダルの商談時間帯表示タブ
    const reserveDate = document.getElementById("modal-reserve-date");
    const confirmDate = document.getElementById("modal-confirm-date");
    const completeDate = document.getElementById("modal-complete-date");
    // 各モーダルの商談方法表示タブ
    const type = document.getElementById("type-select");
    const confirmType = document.getElementById("confirm-type");
    const completeType = document.getElementById("complete-type");
    // 各モーダルの参加人数表示タブ
    const reservationSize = document.getElementById("size-select");
    const confirmSize = document.getElementById("confirm-size");
    const completeSize = document.getElementById("complete-size");
    // 各モーダルのメッセージ表示タブ
    const message = document.getElementById("message-to-supplier");
    const confirmMessage = document.getElementById("confirm-message");
    const completeMessage = document.getElementById("complete-message");
    const typeForm = document.getElementById("type-form");
    const typeError = document.getElementById("type-error");
    const reservationSizeForm = document.getElementById("size-form");
    const reservationSizeError = document.getElementById("size-error");
    const messageForm = document.getElementById("message-form");
    const messageError = document.getElementById("message-error");
    const errorMessage = document.getElementById("error-message-on-confirm");
    const seriesId = document.getElementById("reservation-series-id");
    const weboothId = document.getElementById("webooth-id");
    const selectMeetingType = document.getElementById("type-select");
    // モーダルの初期化
    const closeButtons = document.querySelectorAll('[id^="modal-close-button-"]');
    if (closeButtons.length === 0) {
        return;
    }
    for (const closeButton of closeButtons) {
        closeButton.addEventListener("click", function () {
            // 入力値を初期化する
            // 商談方法;
            type.selectedIndex = 0;
            confirmType.innerText = "";
            completeType.innerText = "";
            // 参加人数
            reservationSize.selectedIndex = 1;
            confirmSize.innerText = "";
            completeSize.innerText = "";
            // メッセージ
            message.value = "";
            confirmMessage.innerText = "";
            completeMessage.innerText = "";
            errorMessage.innerText = "";
            // is-showクラスを外す
            const isShowClass = document.getElementsByClassName("is-show");
            for (const show of isShowClass) {
                show.classList.remove("is-show");
            }
            // バリデーションエラー初期化
            typeForm.classList.remove("form-error");
            typeError.innerText = "";
            messageForm.classList.remove("form-error");
            messageError.innerText = "";
            // 商談方法の初期化
            while (selectMeetingType.options.length > 1) {
                selectMeetingType.remove(1);
            }
        });
    }
    // 「○予約可」の時間帯を取得
    const selectButtons = document.querySelectorAll('[id^="select-button-"]');
    let set = 0; //二重クリック防止用（セレクトボックスのoptionが増えてしまうため）
    // 選択された時間帯についての処理
    for (const selectButton of selectButtons) {
        selectButton.addEventListener("click", function () {
            if (set === 0) {
                set = 1;
                const selectId = selectButton.dataset.id;
                const selectDate = selectButton.dataset.date;
                eventId = selectButton.dataset.eventId;
                // 商談方法を取得する
                const sendData = {
                    id: parseInt(selectId),
                    event_id: parseInt(eventId),
                };
                axios
                    .post("/api/u/box/webooth/reservation-calendar/get-meeting-type", sendData)
                    .then(function (response) {
                    const responseTypes = response.data.meetingTypes;
                    const meetingTypes = JSON.parse(responseTypes);
                    window.console.log(meetingTypes);
                    // 商談方法ドロップダウンに取得した商談方法を書き込む
                    for (let i = 0; i < Object.keys(meetingTypes).length; i++) {
                        let option = document.createElement("option");
                        option.value = i.toString();
                        option.text = meetingTypes[i];
                        selectMeetingType.appendChild(option);
                    }
                    // idを書き込み
                    confirmDate.dataset.id = selectId;
                    // モーダルの日時に選択した時間を表示
                    reserveDate.innerHTML = selectDate.toString();
                    confirmDate.innerHTML = selectDate.toString();
                    completeDate.innerHTML = selectDate.toString();
                    // モーダル表示
                    modalReserve.classList.add("is-show");
                    const modalContentReserve = document.getElementById("modal-content-reserve");
                    if (!modalContentReserve.classList.contains("show")) {
                        modalContentReserve.classList.add("show");
                    }
                    set = 0;
                })
                    .catch(function (error) {
                    if (error.response.status === 400 && error.response.data.result === "NG") {
                        alert(error.response.data.message);
                    }
                    window.console.log(error.response.data);
                    //window.location.reload();
                });
            }
        });
    }
    // 「確認」を押された後の処理
    const confirmButton = document.getElementById("confirm-button");
    confirmButton.addEventListener("click", function () {
        // 入力されたデータを取得(商談方法、メッセージ)
        const selectIndex = type.selectedIndex;
        const selectValue = type.options[selectIndex].value;
        const selectedReservationSizeIndex = reservationSize.selectedIndex;
        const selectedReservationSizeValue = reservationSize.options[selectedReservationSizeIndex].value;
        // バリデーションエラー初期化
        typeForm.classList.remove("form-error");
        typeError.innerText = "";
        reservationSizeForm.classList.remove("form-error");
        reservationSizeError.innerText = "";
        messageForm.classList.remove("form-error");
        messageError.innerText = "";
        // バリデーション処理
        const sendData = {
            type: selectValue,
            reservationSize: selectedReservationSizeValue,
            message: message.value,
            series_id: seriesId.value,
        };
        axios
            .post("/api/u/box/webooth/reservation-calendar/validate", sendData)
            .then(() => {
            // 入力されたデータを確認用モーダルに表示する
            confirmType.innerText = type.options[selectIndex].text;
            completeType.innerText = type.options[selectIndex].text;
            confirmSize.innerText = reservationSize.options[selectedReservationSizeIndex].text;
            completeSize.innerText = reservationSize.options[selectedReservationSizeIndex].text;
            if (message.value != "") {
                confirmMessage.innerText = message.value;
                completeMessage.innerText = message.value;
            }
            // モーダルの表示処理
            modalReserve.classList.remove("is-show");
            modalConfirm.classList.add("is-show");
            const modalContentConfirm = document.getElementById("modal-content-confirm");
            if (!modalContentConfirm.classList.contains("show-content")) {
                modalContentConfirm.classList.add("show-content");
            }
        })
            .catch(function (error) {
            if (error.response.status === 422) {
                // 422: バリデーションエラー
                const errors = error.response.data.errors;
                if (errors.type) {
                    typeForm.classList.add("form-error");
                    typeError.innerText = errors.type[0];
                }
                if (errors.reservationSize) {
                    reservationSizeForm.classList.add("form-error");
                    reservationSizeError.innerText = errors.reservationSize[0];
                }
                if (errors.message) {
                    messageForm.classList.add("form-error");
                    messageError.innerText = errors.message[0];
                }
            }
            else {
                // トリガーしたリクエストの設定に何かしらのエラーがある
                window.location.reload();
            }
        });
    });
    // 確認用モーダルで「戻る」ボタンを押されたときの処理
    const modalBackButton = document.getElementById("modal-back-button");
    modalBackButton.addEventListener("click", function () {
        modalReserve.classList.add("is-show");
        modalConfirm.classList.remove("is-show");
        const modalContentReserve = document.getElementById("modal-content-reserve");
        if (!modalContentReserve.classList.contains("show-content")) {
            modalContentReserve.classList.add("show-content");
        }
        errorMessage.innerText = "";
    });
    // 確認用モーダルで「予約」ボタンを押されたときの処理
    const completeButton = document.getElementById("complete-button");
    completeButton.addEventListener("click", function () {
        showLoading();
        // 入力されたデータを取得(商談方法、メッセージ)
        const selectId = confirmDate.dataset.id;
        const supplierExhibitorName = confirmDate.dataset.supplierExhibitorName;
        const selectIndex = type.selectedIndex;
        const selectValue = type.options[selectIndex].text;
        const reservationSizeIndex = reservationSize.selectedIndex;
        const reservationSizeValue = reservationSize.options[reservationSizeIndex].value;
        // postデータ
        const sendData = {
            id: selectId,
            event_id: eventId,
            series_id: seriesId.value,
            webooth_id: weboothId.value,
            type: selectValue,
            reservationSize: reservationSizeValue,
            message: message.value,
            supplier_exhibitor_name: supplierExhibitorName,
        };
        axios
            .post("/api/u/box/webooth/reservation-calendar/oppotunity", sendData)
            .then(() => {
            // モーダル表示処理
            modalConfirm.classList.remove("is-show");
            modalComplete.classList.add("is-show");
            const modalContentComplete = document.getElementById("modal-content-complete");
            if (!modalContentComplete.classList.contains("show-content")) {
                modalContentComplete.classList.add("show-content");
            }
            hideLoading();
        })
            .catch(function (error) {
            hideLoading();
            if (error.response.status === 400 && error.response.data.result === "SizeOver") {
                const errorMessageText = error.response.data.message;
                errorMessage.innerHTML = errorMessageText;
            }
            else {
                if (error.response.status === 400 && error.response.data.result === "NG") {
                    alert(error.response.data.message);
                }
                window.location.reload();
            }
        });
    });
    // モーダルの外側をクリックした際にモーダルが閉じるように
    const blackBg = document.getElementById("modal-background");
    const confirmblackBg = document.getElementById("confirm-modal-background");
    closePopUp(blackBg);
    closePopUp(confirmblackBg);
    closePopUp(modalComplete);
    function closePopUp(elem) {
        if (!elem)
            return;
        elem.addEventListener("click", () => {
            modalComplete?.classList.remove("is-show");
            window.location.reload();
        });
    }
}
